import { useLocationQuery } from '@/graphql/types/generated';

/** Resolves a location's business name by its odeko uuid. */
export function useLocationName(
  locationId: string,
  options?: { pause?: boolean },
): { fetching: boolean; name: string | undefined } {
  const [{ data, fetching }] = useLocationQuery({
    variables: { odekoUuid: locationId },
    pause: options?.pause,
  });

  return { fetching, name: data?.location?.businessName };
}
